import { X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function TopBannerMobile({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-x-0 top-0 z-[120] bg-[#007a33] h-16 px-4">
      <button
        onClick={onClose}
        className="absolute right-4 top-1/2 -translate-y-1/2 text-white hover:text-gray-200"
        aria-label="close banner"
      >
        <X className="h-5 w-5" />
      </button>

      <div className="h-full flex flex-col items-center justify-center gap-1 text-center">
        <p className="text-sm text-white font-semibold">{t('topBanner.exposed_info')}</p>
        <Link
          to="/scan"
          className="bg-white text-green-800 px-4 py-1.5 rounded-full text-xs font-semibold hover:bg-gray-200"
        >
          {t('topBanner.scan_now')}
        </Link>
      </div>
    </div>
  );
}
